import type { TFieldKey } from "@./suf-store";
import { useSignupFlowStore } from "../hooks/useSignUpFlowStore";
import { useSignupFlowErrorStore } from "../hooks/useSignUpFlowErrorStore";
import { SignupFlowSlug } from "../constants";
import { createFlowValidation } from "../../../shared/createFlowValidation";

import { signupFieldValidations } from "./signupFieldValidations";
import { requiredFieldsBySlug } from "./requiredFieldsBySlug";

const { validateField, getRequiredFieldsForSlug } = createFlowValidation<TFieldKey, SignupFlowSlug>({
  getState: useSignupFlowStore.getState,
  errorStore: useSignupFlowErrorStore.getState(),
  fieldRules: signupFieldValidations,
  requiredFieldsBySlug,
});

export { validateField as validateSignUpField, getRequiredFieldsForSlug };
